import 'keen-slider/keen-slider.min.css';
import KeenSlider from 'keen-slider';

function navigation(slider: any) {
  let wrapper: HTMLElement, dots: HTMLElement, arrowLeft: HTMLElement, arrowRight: HTMLElement;

  function markup(remove: boolean) {
    wrapperMarkup(remove);
    dotMarkup(remove);
    arrowMarkup(remove);
  }

  function removeElement(element: HTMLElement) {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }

  function createDiv(className: string): HTMLElement {
    const div = document.createElement('div');
    const classNames = className.split(' ');
    classNames.forEach((name) => div.classList.add(name));
    return div;
  }

  function arrowMarkup(remove: boolean) {
    if (remove) {
      removeElement(arrowLeft);
      removeElement(arrowRight);

      return;
    }

    arrowLeft = createDiv('arrow arrow--left');
    arrowLeft.addEventListener('click', () => slider.prev());
    arrowRight = createDiv('arrow arrow--right');
    arrowRight.addEventListener('click', () => slider.next());
    const arrowContainer = createDiv('arrow-container');
    arrowContainer.appendChild(arrowLeft);
    arrowContainer.appendChild(arrowRight);
    wrapper.appendChild(arrowContainer);
    if (slider.track.details.slides.length <= 1) {
      arrowContainer.classList.add('arrow-d-none');
    }
  }

  function wrapperMarkup(remove: boolean) {
    if (remove) {
      const parent = wrapper.parentNode;
      while (wrapper.firstChild) {
        if (parent) {
          parent.insertBefore(wrapper.firstChild, wrapper);
        }
      }
      removeElement(wrapper);
      return;
    }

    wrapper = createDiv('navigation-wrapper');
    if (slider.container.parentNode) {
      slider.container.parentNode.appendChild(wrapper);
    }
    wrapper.appendChild(slider.container);
  }

  function dotMarkup(remove: boolean) {
    if (remove) {
      removeElement(dots);
      return;
    }

    dots = createDiv('dots');
    slider.track.details.slides.forEach((_e: any, idx: any) => {
      const dot = createDiv('dot');
      dot.addEventListener('click', () => slider.moveToIdx(idx));
      dots.appendChild(dot);
    });
    wrapper.appendChild(dots);
    if (slider.track.details.slides.length <= 1) {
      dots.classList.add('dots-d-none');
    }
  }

  function updateClasses() {
    const slide = slider.track.details.rel;
    slide === 0 ? arrowLeft.classList.add('arrow--disabled') : arrowLeft.classList.remove('arrow--disabled');
    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add('arrow--disabled')
      : arrowRight.classList.remove('arrow--disabled');

    Array.from(dots.children).forEach(function (dot, idx) {
      idx === slide ? dot.classList.add('dot--active') : dot.classList.remove('dot--active');
    });
  }

  slider.on('created', () => {
    markup(false);
    updateClasses();
  });

  slider.on('optionsChanged', () => {
    markup(true);
    markup(false);
    updateClasses();
  });

  slider.on('slideChanged', () => {
    updateClasses();
  });

  slider.on('destroyed', () => {
    markup(true);
  });
}

const slider = new KeenSlider(
  '#latest-vacancies-slider',
  {
    loop: true,
    slides: {
      perView: 1,
      spacing: 15,
    },
  },
  [navigation],
);

// Add left and right arrows for the main slider
const mainPrevButton = document.getElementById('main-prev');
const mainNextButton = document.getElementById('main-next');

if (mainPrevButton && mainNextButton) {
  mainPrevButton.addEventListener('click', () => {
    slider.prev();
  });

  mainNextButton.addEventListener('click', () => {
    slider.next();
  });
}
// Function to check if there are fewer than 4 slides
function shouldAddPlaceholderSlide() {
  const slidesCount = document.querySelectorAll('.latest-vacancies__slide-item').length;
  return slidesCount < 4;
}

function addPlaceholderSlide() {
  const slideContainer = document.querySelector('.latest-vacancies__slide');
  const placeholderSlide = document.createElement('div');
  placeholderSlide.classList.add('latest-vacancies__slide-item');
  placeholderSlide.innerHTML = `
    <div class="info-empty">
      <div class="info-empty-inner">
        <p>Check back soon for more vacancies</p>
      </div>
    </div>
  `;
  slideContainer?.appendChild(placeholderSlide);
}

if (shouldAddPlaceholderSlide()) {
  addPlaceholderSlide();
}
